export default "__VITE_ASSET__fe105110__"